import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import AccountService from '../account.service';
import { IPlan } from '@/shared/model/plan.model';
import currencyFormatter from 'currency-formatter';
import { stripeKey, stripeOptions } from '@/shared/config/stripe-config';
import UpgradeService from './upgrade.service';
import PlanService from '@/entities/plan/plan.service';
import { IAddon } from '@/shared/model/addon.model';
import AddonService from '@/entities/addon/addon.service';
import ElbSubscriptionService from '@/entities/elb-subscription/elb-subscription.service';
import UserActivityService from '@/entities/user-activity/user-activity.service';
import { getCheckoutPlanOptionFromNickname } from '@/shared/data/plan-option-util';
import StripePlanService from '@/shared/data/stripe/stripe-plan.service';
import { buildInvoiceItem, getAdditionalAuthors, getAddonItem, getIvoiceSubscriptionItems,
  getRelated, hasLearner, removeExistingPlans, removeExistingSubscription, removePlanByMetadata,
  removePlanByNamePartial, showQtyInSelect } from '@/shared/data/plan-utils';

@Component({
  components: {
    // StripeElements,
    // StripeElement,
    // ProductItem
  }
})
export default class Payment extends Vue {

  @Inject('accountService')
  private accountService: () => AccountService;

  @Inject('upgradeService')
  private upgradeService: () => UpgradeService;

  @Inject('planService')
  private planService: () => PlanService;

  @Inject('addonService')
  private addonService: () => AddonService;

  @Inject('elbSubscriptionService')
  private elbSubscriptionService: () => ElbSubscriptionService;

  @Inject('userActivityService')
  private userActivityService: () => UserActivityService;

  @Inject('stripePlanService')
  private stripePlanService: () => StripePlanService;

  @Prop({type: String, default: null})
  planNickname: string;

  @Prop({type: Object, default: null})
  checkoutUserDto: any;

  @Prop({type: Object, default: null})
  subscription: any;

  @Prop({type: String, default: 'Subscribe'})
  checkoutBtn: string;

  @Prop({type: String, default: 'Checkout'})
  title: string;

  @Prop({type: Boolean, default: false})
  showCancel: boolean;

  @Prop({type: Boolean, default: true})
  allowPlanChange: boolean;

  @Prop({type: Boolean, default: false})
  enterpriseToStripe: boolean;

  @Prop({type: Array, default: null})
  subscriptions: any;

  @Prop({type: Boolean, default: true})
  showTitleBar: boolean;

  @Prop({type: String, default: null})
  couponCode: string;


  public billingPlanMap = null;
  public pleaseWait = false;
  public initialLoad = false;
  public showCouponControls = false;
  public stripeCustomerData = null;
  public stripeEstimates = null;
  public loggedUser = null;
  public estimateToken = null;
  public couponDescription = null;
  public couponError = false;
  public showCouponLineItem = false;
  public cardInfoCompleted = false;
  public cardError = '';
  public rules = {
    required: (v) => {
      if (!v) {
        return 'Must be valid number.';
      }
      if (v > 0 && v <= 999) {
        return true;
      }
      return 'Must be valid number.';
    }
  };
  public cantChange = false;
  public plan: IPlan = null;
  public plans: IPlan[] = [];
  public isSilver = false;
  public userAddOnList: IAddon[] = [];
  public userAddOn = null;
  public billingCycle = 'year';
  public showPlans = false;
  public billingCycles = [
    { text: 'Billed Annually', value: 'year' },
    { text: 'Billed Monthly', value: 'month' }
  ];
  public userCountOptions = [0, 50, 100, 250, 500, 1000, 2000, 3000, 4000, 5000];
  public authorCountOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  public authorCount = 1;
  public userCount = null;
  public info = {};
  public retryCount = 0;
  public showCustomControls = false;
  public changePaymentMethod = false;
  public coupon = null;
  public couponAmount = null;
  public invoiceItems = [];
  public subscriptionItems = [];
  public selectedPlans = [];
  public availablePlans = [];
  public allPlans = [];
  public plansDialog = false;
  public stripeKey = stripeKey;
  public stripeOptions = stripeOptions;
  public elementsOptions = {};
  public cardFocus = false;
  public eulaSelected = false;
  public cardOptions =  {
    // reactive
    // remember about Vue 2 reactivity limitations when dealing with options
    value: {
      postalCode: '',
    },
    iconStyle: 'default',
    style: {
      base: {
        color: 'rgba(0,0,0,.6)',
        lineHeight: '30px',
        fontSize: '16px',
        fontFamily: '"proxima-nova", "Open Sans", sans-serif',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: 'rgba(0,0,0,.6)',
        },
      },
      invalid: {
        color: '#e5424d',
        ':focus': {
          color: '#303238',
        },
      },
    },
  };


  @Watch('billingCycle')
  billingCycleChange() {
    this.updateSubscriptionItems();
    this.getEstimate();
  }


  async created() {
    this.stripeKey = await this.upgradeService().getStripePublishableKey(stripeKey);
    this.allPlans = await this.upgradeService().getAllPlans();


    this.allPlans.forEach((elm) => {
      elm['disabled'] = false;
    });
    this.loggedUser = this.accountService().authenticated ? this.$store.getters.account : null;
    this.setBillingMap();

  }

  async mounted() {
    this.pleaseWait = true;
    this.initialLoad = true;

    const item = await this.upgradeService().getPlanById(this.planNickname);
    const subId = this.subscription ? this.subscription.id : null;
    const subsItem = {
      productName: item.productName,
      quantity: hasLearner(item.priceId) ? 100 : 1,
      priceId: item.priceId,
      interval: item.interval,
      unitPrice: item.unitPrice,
      deleted: false,
      added: true,
      billing: item.billing,
      subscriptionId: subId,
      // learner: learner
    };

    this.subscriptionItems.push(subsItem);


    if (this.enterpriseToStripe) {
      this.stripeCustomerData = await this.upgradeService().stripeCreateCustomer(this.checkoutUserDto);

      const paginationQuery = {
        page: 0,
        size: 50,
        sort: ['id,asc'],
        predicate : [
          {name: 'organizationId.equals', value: this.subscription.organizationId}
        ]
      };
      this.subscriptions = await this.elbSubscriptionService().retriveAsync(paginationQuery);

      this.cantChange = true;
      await this.subscriptionsToItems();

      this.authorCount = this.currAuthorCount;
      this.billingCycle = this.subscription.plan.interval === 'MONTH' ? 'month' : 'year';
      if (this.subscription && this.subscription.addons && this.subscription.addons.length > 0) {
        this.subscription.addons.forEach((element) => {
          this.userAddOn = element;
        });
      }

    }
    // else
    if (this.accountService().authenticated) {
      if (!this.checkoutUserDto) {
        // @todo: get application user here
        this.stripeCustomerData = await this.upgradeService().getStripeCustomer();

        if (this.subscriptionChangeScheduled) {
          this.$emit('hasDowngrade');
          this.$router.go(-1);
          return;
        }
        this.billingCycle = this.getCurrentBillingCycle;
        if (this.currAuthorCount) {
          this.authorCount = this.currAuthorCount;
        }
        // if (this.stripeCustomerData.delinquent || this.paymentFailed) this.updateBillingMode = true // just in case they try to upgrade while being delinquent
      }
    }

    this.getEstimate();
    this.initialLoad = false;

    if (this.couponCode) {
      this.coupon = this.couponCode;
      this.showCouponControls = true;
      this.applyCoupon();
    }
  }

  public async subscriptionsToItems() {
    this.subscriptionItems = [];

    // need to redo this logic
    for (const key in this.subscriptions) {
      const sub = this.subscriptions[key];
      this.cantChange = !(sub.status === 'expired');
      const item = this.allPlans.find((val) => val.priceId === sub.plan.stripeId);

      if (item) {
        getAddonItem(sub.addons, item, this.allPlans);

        let authorQty = sub.quantity;
        const learnerQty = this.getAddonQuantity(sub.addons, 'learnerCount');
        const learnerAuthorList = item.price.metadata && item.price.metadata.learnerAuthorList ?
              JSON.parse(item.price.metadata.learnerAuthorList) : null;

        if (learnerAuthorList && learnerQty) {
          const author = learnerAuthorList.find((val) => val.learner === learnerQty);
          if (author) {
            authorQty = author.author;
          }
        }
        const related = getRelated(this.allPlans, item);
        const relatedAuthor = this.buildSubscriptionItem(related['relatedAuthor'], learnerQty, null);
        const relatedLearner = this.buildSubscriptionItem(related['relatedLearner'],1, null);
        const subsItem = this.buildSubscriptionItem(item, authorQty, sub.id);
        subsItem.relatedAuthor = relatedAuthor;
        subsItem.relatedLearner = relatedLearner;

        this.billingCycle = item.price.recurring.interval;

        this.subscriptionItems.push(subsItem);
      }

      if (sub.addons && sub.addons.length > 0) {
        for (const index in sub.addons) {
          const addon = sub.addons[index];

          if (addon && addon.type === 'userCount') {
            const priceId = item.interval === 'month' ? addon.monthlyStripeId : addon.yearlyStripeId;
            const addonItem = this.allPlans.find((val) => val.priceId === priceId);

            if (addonItem) {
              const addonSubsItem = {
                productName: addonItem.productName,
                quantity: addon.maxValue,
                priceId: addonItem.priceId,
                interval: addonItem.interval,
                unitPrice: addonItem.unitPrice,
                deleted: false,
                added: true,
                billing: addonItem.billing
              };

              this.subscriptionItems.push(addonSubsItem);
            }
          }
        }

      }
    }
  }

  public getAddonQuantity(addons, type) {
    for (const index in addons) {
      const addon = addons[index];

      if (addon && addon.type === type) {
        return addon.maxValue;
      }
    }
    return 100;
  }

  public buildSubscriptionItem(item: any, quantity, subId): any {
    if (!item) {
      return null;
    }

    const subsItem = {
        productName: item.productName,
        quantity,
        priceId: item.priceId,
        interval: item.interval,
        unitPrice: item.unitPrice,
        deleted: false,
        added: true,
        billing: item.billing,
        subscriptionId: subId
      };

    return subsItem;

  }


  public get hasAnnaulPriceOnly() {
    if (this.subscription) {
      return this.subscription && (
        this.subscription.plan.nickname.includes('_gov') ||
        this.subscription.plan.nickname.includes('_edu') ||
        this.subscription.plan.nickname.includes('_k12')
      );
    }

    return false;
  }


  public updateSubscriptionItems() {
    const cleanPlan = getCheckoutPlanOptionFromNickname(this.planNickname, this.allPlans);
    for (let i = 0; i < this.subscriptionItems.length; i++) {
      if (this.subscriptionItems[i].relatedLearner) {
        this.subscriptionItems[i].relatedLearner = this.switchPeriod(cleanPlan, this.subscriptionItems[i].relatedLearner);
      }
      if (this.subscriptionItems[i].relatedAuthor) {
        this.subscriptionItems[i].relatedAuthor = this.switchPeriod(cleanPlan, this.subscriptionItems[i].relatedAuthor);
      }
      this.subscriptionItems[i] = this.switchPeriod(cleanPlan, this.subscriptionItems[i]);
    }
  }

  public switchPeriod(cleanPlan, subscriptionItem) {
    const plan = this.billingPlanMap.get(subscriptionItem.priceId);
    if (plan) {
      subscriptionItem.interval = plan.interval;
      subscriptionItem.unitPrice = plan.unitPrice;
      subscriptionItem.priceId = plan.priceId;
      subscriptionItem.billing = plan.billing;
      subscriptionItem.unitAmount = currencyFormatter.format(subscriptionItem.unitPrice / 100.0, { code: 'USD' });
    }
    return subscriptionItem;
  }


  public retrievePlan() {
    this.planService()
      .findByNickname(this.planNickname)
      .then((res) => {
        this.plan = res;
        this.isSilver = res.nickname.includes('silver');
      });
  }


  public updateAvailablePlans() {
    const planNickname = this.subscription ? this.subscription.plan.nickname : null;
    const cleanPlans = getCheckoutPlanOptionFromNickname(planNickname, this.allPlans);
    this.availablePlans = cleanPlans.filter((val) => val['interval'] === this.billingCycle);

    // remove CVR viewers
    removePlanByNamePartial(this.availablePlans, 'viewers');

    // remove Ptlatinum
    removePlanByNamePartial(this.availablePlans, 'Platinum');

    // remove Ptlatinum
    removePlanByNamePartial(this.availablePlans, 'Silver');

    // remove Additional Authors
    removePlanByNamePartial(this.availablePlans, 'Additional Author');

    // remove by metadata
    removePlanByMetadata(this.availablePlans);

    // remove existing plans
    removeExistingPlans(this.subscriptionItems, this.availablePlans);

    // remove non e-commerce plans
    removeExistingSubscription(this.subscriptions, this.availablePlans);

    const silver = this.subscriptionItems.find((val) => val.productName.includes('Silver'));
    if (silver) {
      this.availablePlans = [];
      return;
    }


    const gold = this.subscriptionItems.find((val) => val.productName.includes('Gold'));
    if (gold) {
      removePlanByNamePartial(this.availablePlans, 'Silver');
      removePlanByNamePartial(this.availablePlans, 'Gold');
    }
  }

  public setBillingMap() {
    if (this.billingPlanMap) {
      return;
    }

    this.billingPlanMap = new Map();
    for (const plan of this.allPlans) {
      if ( plan.price.metadata && plan.price.metadata.related ) {
        const related = JSON.parse(plan.price.metadata.related);
        this.billingPlanMap.set(plan.priceId, this.allPlans.find((p) => related.billing === p.priceId));
      }
    }
  }

  public getEstimate() {
    this.stripeEstimates = null;
    this.pleaseWait = true;
    const userDto = this.getUserDto();

    if (userDto.subscriptionItemCollection.length === 0) {
      this.invoiceItems = [];
      this.subscriptionItems = [];
      this.updateAvailablePlans();
      this.pleaseWait = false;

      if (this.retryCount === 0) {
        this.$swal.fire({
          icon: 'error',
          title: 'At least one plan is required',
          confirmButtonColor: '#000C19',
          footer: '<strong>Try Again</strong>'
        })
        .then(() => {
          this.retryCount++;
          window.location.reload();
        });


      }

      return;
    }

    if (this.estimateToken) {
      userDto.country = this.estimateToken.token.card.country;
      userDto.postalCode = this.estimateToken.token.card.address_zip;
    }
    this.upgradeService().getStripePlanEstimates(userDto)
    .then((response) => {
      this.stripeEstimates = response;
      this.updateAvailablePlans();
      this.loadIvoiceSubscriptionItems();
      this.pleaseWait = false;
    })
    .catch((err) => {
      let msg = 'Sometning went wrong. Please try again.';
      if (err && err.response && err.response.data && err.response.data.title) {
        msg = err.response.data.title;
      }
      this.$swal.fire({
        icon: 'error',
        text: msg,
        confirmButtonColor: '#000C19',
        showConfirmButton: true,
        timer: 4500
      });
    })
    .finally(() =>{
      this.pleaseWait = false;
    });
  }

  public invoiceListUpdated(itemRemoved) {
    for (let i = 0; i < this.subscriptionItems.length; i++) {
      if (itemRemoved.priceId === this.subscriptionItems[i].priceId) {

        if (itemRemoved.relatedAuthor) {
          const authorIndex = this.subscriptionItems.findIndex((s) => s.priceId === itemRemoved.relatedAuthor.priceId);
          if (authorIndex !== -1) {
            this.removeItem(authorIndex);
          }
        }

        if (itemRemoved.relatedLearner) {
          const learnerIndex = this.subscriptionItems.findIndex((s) => s.priceId === itemRemoved.relatedLearner.priceId);
          if (learnerIndex !== -1) {
            this.removeItem(learnerIndex);
          }
        }
        this.removeItem(i);
      }
    }
    this.getEstimate();
  }

  public removeItem(itemIndex) {
    this.subscriptionItems[itemIndex].deleted = true;
    if (this.subscriptionItems[itemIndex].added) {
      this.subscriptionItems.splice(itemIndex, 1);
    }
  }

  public invoiceListItemRetored(itemRestored) {
    for (let i = 0; i < this.subscriptionItems.length; i++) {
      if (itemRestored.priceId === this.subscriptionItems[i].priceId) {
        this.subscriptionItems[i].deleted = false;
      }
    }
    this.getEstimate();
  }

  public async changeToItemToAuthorOnly(item, additionalAuthors) {
    const qty = item.learnerAuthorList[0].author + additionalAuthors;
    const index = this.subscriptionItems.findIndex((s) => s.priceId === item.priceId);
    if (index !== -1) {
      this.subscriptionItems.splice(index, 1);
      if (item.relatedAuthor) {
        // need to remove additional author prices
        this.removeFromSubscriptionItems(this.subscriptionItems.findIndex((s) => s.priceId === item.relatedAuthor.priceId));
      }
      const newItem = this.allPlans.find((val) => val.priceId === item.authorOnly);

      if (newItem) {
        let learner = null;
        if (newItem.price.metadata) {
          learner = this.allPlans.find((val) => val.priceId === newItem.price.metadata.learner);
          learner = buildInvoiceItem(learner, this.allPlans);
          learner.quantity = 100;
        }
        const subsItem = {
          productName: newItem.productName,
          quantity: qty,
          priceId: newItem.priceId,
          interval: newItem.interval,
          unitPrice: newItem.unitPrice,
          deleted: false,
          added: true,
          billing: newItem.billing,
          learner,
          subscriptionId: this.subscription ? this.subscription.id : null
        };

        this.subscriptionItems.push(subsItem);
      }
    }
  }

  public toLearner(learner, index, item) {
    if (index !== -1) {
      this.invoiceItems.splice(index, 1);
      this.invoiceItems.splice(index, 1, learner);

      const itemTndex = this.subscriptionItems.findIndex((s) => s.priceId === item.priceId);
      if (itemTndex !== -1) {
        const newItem = this.allPlans.find((val) => val.priceId === learner.priceId);
        if (newItem) {
          const subsItem = {
            productName: learner.productName,
            quantity: learner.quantity,
            priceId: newItem.priceId,
            interval: newItem.interval,
            unitPrice: newItem.unitPrice,
            deleted: false,
            added: true,
            billing: newItem.billing
          };
          this.subscriptionItems.splice(itemTndex, 1);
          this.subscriptionItems.splice(itemTndex, 1, subsItem);
        }
      }
    }
  }

  public removeFromSubscriptionItems(itemTndex) {
    if (itemTndex !== -1) {
      this.subscriptionItems.splice(itemTndex, 1);
    }
  }

  public invoiceItemQuantityChange(item, additionalAuthors) {
    if (item.quantity === 0 && item.authorOnly) {
      // need to replace item with author only
      this.changeToItemToAuthorOnly(item, additionalAuthors);
    } else {

      this.invoiceItems.forEach((elm) => {
        if (elm.id === item.id) {
          elm.quantity = item.quantity;
        }
      });

      this.subscriptionItems.forEach((elm) => {
        if (elm.priceId === item.priceId) {
          elm.quantity = parseInt(item.quantity);
        }
      });

      this.addOrUpdateAdditionalAuthors(item, additionalAuthors);
    }

    this.getEstimate();
  }

  public removeRelated(item) {
    const subscriptionItem = this.subscriptionItems.find((s) => s.priceId === item.priceId);
    if (subscriptionItem) {
      subscriptionItem.relatedAuthor = null;
      subscriptionItem.relatedLearner = null;
    }
  }

  public addOrUpdateAdditionalAuthors(item, additionalAuthors?) {
    if (item.relatedAuthor) {
      const index = this.subscriptionItems.findIndex((s) => s.priceId === item.relatedAuthor.priceId);
      if (index !== -1 && additionalAuthors === 0) {
        this.removeItem(index);
        this.removeRelated(item);
      } else {
        this.subscriptionItems[index].quantity = parseInt(additionalAuthors);
      }
    } else {
      const additional = getAdditionalAuthors(item, additionalAuthors, this.allPlans);
      if (additional) {
        this.subscriptionItems.push(additional);
        this.updateRelated(item.priceId, buildInvoiceItem(additional, this.allPlans));
      }
    }

  }

  public updateRelated(priceId, related) {
    const subscriptionItem = this.subscriptionItems.find((s) => s.priceId === priceId);
    if (subscriptionItem) {
      subscriptionItem.relatedAuthor = related;
    }
  }

  public getUnitPriceForTier(tiers, quantity) {
    for (let i = 0; i < tiers.length; i++) {
      const tier = tiers[i];
      if (tier.upTo == null) {
        return tier.unitAmountDecimal;
      }
      if (tier.upTo >= quantity) {
        return tier.unitAmountDecimal;
      }
    }
  }


  public loadIvoiceSubscriptionItems() {
    this.invoiceItems = getIvoiceSubscriptionItems(this.subscriptionItems, this.allPlans);
  }

  public addViewers() {
    const item = this.allPlans.find((val) => val.productName.includes('viewers') && val.interval === this.billingCycle);
    const platinum = this.selectedPlans.find((val) => val.productName.includes('Platinum'));
    if (item && platinum) {
      const viewers = {
        quantity: 50,
        priceId: item.priceId,
        interval: item.interval,
        deleted: false,
        added: true,
        productName: item.productName,
        unitPrice: item.unitPrice,
        billing: item.billing
      };
      this.selectedPlans.push(viewers);
    }
  }

  public removeRelatedAuthorOnly() {
    const authorOnlyToRemove = this.selectedPlans.find((val) => val.price.metadata && val.price.metadata.authorOnly);
    if (authorOnlyToRemove) {
      const authorOnlyPlanIndex = this.subscriptionItems.findIndex((val) => val.priceId === authorOnlyToRemove.price.metadata.authorOnly);
      if (authorOnlyPlanIndex >= 0) {
        this.removeItem(authorOnlyPlanIndex);
      }
    }
  }

  public removeHighlander() {
    const highlanderToRemove = this.selectedPlans.find((val) => val.price.metadata && val.price.metadata.highlander);
    if (highlanderToRemove) {
      const highlanders = highlanderToRemove.price.metadata.highlander.split('|');
      if (highlanders) {
        highlanders.forEach((highlander) => {
          const highlanderPlanIndex = this.subscriptionItems.findIndex((val) => val.priceId === highlander);
          if (highlanderPlanIndex >= 0) {
            this.removeItem(highlanderPlanIndex);
          }
        });
      }
    }
  }

  public addPlans() {
    this.addViewers();
    this.removeRelatedAuthorOnly();
    this.removeHighlander();
    for (let i = 0; i < this.selectedPlans.length; i++) {
      const quantity = showQtyInSelect(this.selectedPlans[i]) ? 100 : 1;
      const subsItem = {
        quantity,
        priceId: this.selectedPlans[i].priceId,
        interval: this.selectedPlans[i].interval,
        deleted: false,
        added: true,
        productName: this.selectedPlans[i].productName,
        unitPrice: this.selectedPlans[i].unitPrice,
        billing: this.selectedPlans[i].billing
      };

      this.subscriptionItems.push(subsItem);
    }

    if (this.selectedPlans.length > 0) {
      this.getEstimate();
    }


    this.selectedPlans = [];
    this.plansDialog = false;
  }

  public getPlanNickname() {
    let planName = this.plan ? this.plan.nickname : this.planNickname;
    if (this.billingCycle === 'monthly' && !planName.includes('_monthly')) {
      planName += '_monthly';
    }
    return planName;
  }

  public getUserDto() {
    const dto = {
      id: this.checkoutUserDto ? this.checkoutUserDto.id : this.loggedUser.userId,
      email: this.checkoutUserDto ? this.checkoutUserDto.email : this.loggedUser.email,
      planNickname: this.getPlanNickname(),
      firstName: this.checkoutUserDto ? this.checkoutUserDto.firstName : this.loggedUser.firstName,
      lastName: this.checkoutUserDto ? this.checkoutUserDto.lastName : this.loggedUser.lastName,
      organizationName: this.checkoutUserDto ? this.checkoutUserDto.organizationName : this.loggedUser.organizationName,
      organizationId: this.checkoutUserDto ? this.checkoutUserDto.organizationId : this.loggedUser.organizationId,
      numberOfAuthors: this.authorCount != null && this.authorCount > 0 ? this.authorCount : 1,
      coupon: this.couponError ? null : this.coupon,
      billingCycle: this.billingCycle,
      country: null,
      postalCode: null,
      token: null,
      prorationDate: null,
      subscription: this.subscription  ?  this.subscription : null,
      userAddon: this.userAddOn ? this.userAddOn : null,
      subscriptionItemCollection: this.subscriptionItems
    };
    return dto;
  }

  public async applyCoupon() {
    if (this.coupon == null) {
      this.showCouponControls = false;
      return;
    }
    this.pleaseWait = true;
    this.couponError = false;
    this.couponAmount = null;
    this.showCouponLineItem = false;
    try {
      const couponData = await this.upgradeService().getStripeCoupon(this.coupon);
      this.pleaseWait = false;
      if (couponData.valid) {
        if (couponData.amount_off != null) {
          this.couponDescription = `${currencyFormatter.format(Number.parseInt(couponData.amount_off) / 100.0, { code: 'USD' })} off`;
          this.couponAmount = currencyFormatter.format(Number.parseInt(couponData.amount_off) / 100.0, { code: 'USD' });
        } else{
          this.couponDescription = `${couponData.percent_off}% off`;
      }

        if (couponData.duration === 'once') {
          this.couponDescription += ' initial subscription';
        }
        this.showCouponLineItem = true;
        this.getEstimate();
      } else {
        // this.coupon = null;
        this.couponError = true;
        this.couponDescription = 'Coupon is not active or is not valid for this items.';
        this.pleaseWait = false;

      }
    } catch (e) {
      this.couponError = true;
      this.couponDescription = 'Coupon is not active or is not valid for this items.';
      this.pleaseWait = false;
    }
  }

  public get last4Digits() {
    return this.stripeCustomerData && this.stripeCustomerData.sources.data.length && this.stripeCustomerData.sources.data[0].last4;
  }

  public get isValidCoupon() {
    if (this.couponError) {
      return 'Coupon is not active or is not valid for this items.';
    } else {
      return true;
    }
  }

  public get isValidAuthorCount() {
    return this.authorCount && this.authorCount > 0;
  }

  public get discountAmount() {
    if (this.couponAmount) {
      return '-' + this.couponAmount;
    }

    const subscriptionLineItems = this.stripeEstimates.lines.data.filter((lineItem) => lineItem.type === 'subscription');

    if (subscriptionLineItems && subscriptionLineItems.length > 0) {
      let discount = 0;
      for (const element of subscriptionLineItems) {
        if (element.discount_amounts && element.discount_amounts.length > 0) {
          discount += Math.abs(element.discount_amounts[0].amount);
        }
      }

      if (discount > 0) {
        return '-' + currencyFormatter.format(discount / 100.0, { code: 'USD' });
      }
    }

    return null;
  }

  public get getCurrentBillingCycle() {
    let cycle = 'year';
    try {
      cycle = this.stripeCustomerData.subscriptions.data[0].items.data['0'].plan.interval === 'month' ? 'month' : 'year';
    } catch (e) {
      console.log(e);
    }
    return cycle;
  }

  public get currAuthorCount() {
    return this.subscription ? this.subscription.quantity : this.authorCount;
  }


  public get subscriptionNotRenew() {
    return this.stripeCustomerData &&
           this.stripeCustomerData.subscriptions &&
           this.stripeCustomerData.subscriptions.data &&
           this.stripeCustomerData.subscriptions.data.length ? this.stripeCustomerData.subscriptions.data[0].cancel_at_period_end : false;
  }

  public get scheduledDowngrade() {
    return this.stripeCustomerData &&
           this.stripeCustomerData.subscriptions &&
           this.stripeCustomerData.subscriptions.data &&
           this.stripeCustomerData.subscriptions.data.length ? this.stripeCustomerData.subscriptions.data[0].cancel_at_period_end : false;
  }

  public get subscriptionChangeScheduled() {
    return this.subscriptionNotRenew || this.scheduledDowngrade;
  }

  public get upgradeRequiresImmediateFunds() {
    return !this.checkoutUserDto && this.stripeEstimates && Number.parseInt(this.stripeEstimates.metadata.cost) >= 0;
  }

  public get getTotalImmediateEstimate() {
    if (this.upgradeRequiresImmediateFunds) {
      return currencyFormatter.format(Number.parseInt(this.stripeEstimates.metadata.cost) / 100.0, { code: 'USD' });
    } else if (this.checkoutUserDto) {
      let amountDue = this.stripeEstimates.amount_due;
      if (this.taxValue) {
        amountDue -= this.taxValue;
      }
      return currencyFormatter.format(amountDue / 100.0, { code: 'USD' });
    } else { // null immediate estimate means schedule a downgrade
      return null;
    }
  }

  public get getProrationLineItem() {
    return this.stripeEstimates.lines.data.find((lineItem) => lineItem.proration);
  }


  public get getPlanPriceEstimate() {
    return currencyFormatter.format(this.getSubscriptionLineItem.plan.amount / 100.0, { code: 'USD' });
  }

  public get getQtyEstimate() {
    return this.getSubscriptionLineItem.quantity;
  }


  public formatPrice(price) {
    return currencyFormatter.format(price / 100.0, { code: 'USD' });
  }


  public planChange(plan: IPlan) {
    this.plan = plan;
    this.planNickname = plan.nickname;
    this.isSilver = plan.nickname.includes('silver');
    this.$emit('planChange', this.plan);
    if (!plan.nickname.includes('platinum')) {
      this.userAddOn = null;
    }
    if (this.authorCount && this.authorCount > 0) {
      if (this.isSilver) {
        this.authorCount = 1;
      }
    }
    this.getEstimate();
  }

  public async createToken() {
    const groupComponent = this.$refs.elms;
    const cardComponent = this.$refs.card;
    // Get stripe element
    const cardElement = cardComponent['stripeElement'];

    const token = await groupComponent['instance'].createToken(cardElement);
    return token;

}


  public async changeCardInput(event) {
    this.cardError = event.error != null ? event.error.message : '';
    this.cardInfoCompleted = event.complete;

    if (this.authorCount) {
      if (event.complete) {
        this.estimateToken = await this.createToken();
        if (this.estimateToken.error) {
          console.log('error token creation:', this.estimateToken.error);
          this.cardError = this.estimateToken.error.message;

        } else {
          this.getEstimate();
        }

      } else if (this.estimateToken) {
        this.estimateToken = null;
        this.getEstimate();
      }
    }
  }

  public previousState() {
    this.$router.go(-1);
  }

  public async completeEnterpriseToStripe() {
    this.pleaseWait = true;
    const userDTO = this.getUserDto();
    try {
      if (!this.cardOnFile) {
        const data = await this.createToken();
        if (data.error) {
          this.pleaseWait = false;
          return;
        }

        userDTO.token = data.token.id;
        userDTO.country = data.token.card.country;
        userDTO.postalCode = data.token.card.address_zip;
      }
    } catch (e) {
      console.log('error token creation:', e);
      this.pleaseWait = false;
    }

    try {
      await this.upgradeService().stripEenterpriseCheckout(userDTO);
      await this.userActivityService()
      .createEvent(this.$store.getters.account, this.$store.getters.currentLocation, 'converted subscription to ecommerce' , 'converted' );
      this.$emit('done');
    } catch (e) {
      console.log('error with checkout:', e);
      this.cardError = e.response.data.title;
      this.pleaseWait = false;
    }

  }

  public async completeCheckout() {
    if (this.enterpriseToStripe) {
      return this.completeEnterpriseToStripe();
    }
    this.pleaseWait = true;
    const userDTO = this.getUserDto();
    try {
      const data = await this.createToken();
      if (data.error) {
        this.pleaseWait = false;
        return;
      }
      userDTO.token = data.token.id;
      userDTO.country = data.token.card.country;
      userDTO.postalCode = data.token.card.address_zip;
      try {
        await this.upgradeService().stripeCheckout(userDTO);
        if (this.accountService().authenticated) {
          await this.userActivityService()
          .createEvent(this.$store.getters.account, this.$store.getters.currentLocation, 'purchased subscription' , 'purchased' );
        }
        this.$emit('done');
      } catch (e) {
        this.cardError = e.response.data.title;
        this.pleaseWait = false;
      }
    } catch (e) {
      console.log('error token creation:', e);
      this.pleaseWait = false;
    }
  }

  public get planName() {
    return 'Gold Suite';
  }

  public get quantity() {
    return 4;
  }

  public getTotalPrice() {

  }

  public get getTaxInfo() {
    let message = 'Fill in card information for tax estimate';
    if (this.estimateToken || this.cardOnFile) {
      // const tax = this.taxPercentage
      message = 'Estimate tax';
    }
    return message;
  }

  public get noCardInfo() {
    return !(this.estimateToken || this.cardOnFile);
  }

  public get taxPercentage() {
    if (this.stripeEstimates.default_tax_rates && this.stripeEstimates.default_tax_rates.length > 0) {
      return this.stripeEstimates.default_tax_rates[0].percentage;
    }

    return 0;
  }

  public get taxValue() {
    if (this.checkoutUserDto) {
      return this.stripeEstimates.tax;
    } else if (this.stripeEstimates.metadata) {
      return this.stripeEstimates.metadata.tax;
    }

    return 0;
  }

  public get taxAmount() {
    if (this.estimateToken || this.cardOnFile) {
      return currencyFormatter.format(this.taxValue / 100.0, { code: 'USD' });
    }
    return null;
  }

  public get cardOnFile() {
    return !this.initialLoad && this.accountService().authenticated &&
            this.stripeCustomerData != null && this.stripeCustomerData.default_source != null;
  }

  public get getSubscriptionLineItem() {
    return this.stripeEstimates.lines.data.find((lineItem) => lineItem.type === 'subscription');
  }

  public get getUserCountSubscriptionLineItem() {
    if (this.userAddOn) {
      return this.stripeEstimates.lines.data.find((lineItem) => lineItem.price.id === this.priceId);
    }

    return null;
  }

  public get priceId() {
    if (this.userAddOn) {
      return this.billingCycle === 'monthly' ? this.userAddOn.monthlyStripeId : this.userAddOn.yearlyStripeId;
    }

    return null;
  }


  public get getTotalRecurringEstimate() {
    return currencyFormatter.format(this.stripeEstimates.amount_due / 100.0, { code: 'USD' });
  }

  public get getSubTotal() {
    return currencyFormatter.format(5196, { code: 'USD' });
  }

  public get getPlanPrice() {
    return currencyFormatter.format(this.getSubscriptionLineItem.price.unit_amount / 100.0, { code: 'USD' });
  }

  public get getItemTotal() {
      return currencyFormatter.format(this.getSubscriptionLineItem.price.unit_amount * this.authorCount / 100.0, { code: 'USD' });
  }

  public get getUserCountTotal() {
    if (this.userAddOn && this.userAddOn.maxValue > 0) {
      return currencyFormatter.format(this.getUserCountSubscriptionLineItem.amount  / 100.0, { code: 'USD' });
    }
    return null;
  }

  public get totalText() {
    return this.billingCycle === 'month' ? 'Month Total' : 'Annual Total';
  }

  public get hasSiverPlan() {
    return this.subscriptionItems.find((item) => item.productName.includes('Silver'));
  }


}
